import { createFeature, createReducer, createSelector } from '@ngrx/store';

import { dayjs } from '../../../../core/dayjs/dayjs';

import { dispatchCalendarRemarksDialogReducers } from './dispatch-calendar-remarks-dialog.reducer';
import { dispatchCalendarRemarksDialogInitialState } from './dispatch-calendar-remarks-dialog.state';

export const dispatchCalendarRemarksDialogFeature = createFeature({
    name: 'dispatchCalendarRemarksDialog',
    reducer: createReducer(dispatchCalendarRemarksDialogInitialState, ...dispatchCalendarRemarksDialogReducers),
    extraSelectors: ({ selectSelectedDates }) => ({
        selectSelectedDatesAsDate: createSelector(
            selectSelectedDates,
            (dates) => dates?.map((d) => dayjs(d).toDate()) ?? null,
        ),
    }),
});
